
import { useI18n } from "vue-i18n";
import { defineComponent, ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { Field, Cell, Icon, Skeleton, Calendar, DatetimePicker, ActionSheet } from "vant";

export default defineComponent({
  name: "PICKER",
  props: ["placeholder", "modelValue"],
  components: {
    [Field.name]: Field,
    [Cell.name]: Cell,
    [Icon.name]: Icon,
    [Skeleton.nane]: Skeleton,
    [Calendar.name]: Calendar,
    [DatetimePicker.name]: DatetimePicker,
    [ActionSheet.name]: ActionSheet
  },
  setup(props, content) {
    const route = useRoute();
    const { t } = useI18n();
    const showSheet = ref(false);
    const value = ref(props.modelValue);
    const minData = new Date();

    const onDateTimePickerHandler = val => {
      const year = new Date(val).getFullYear().toString();
      let month = (new Date(val).getMonth() + 1).toString();
      if (month.length < 2) {
        month = `0${month}`;
      }
      value.value = month + "/" + year.substring(year.length - 2);
      showSheet.value = false;
      content.emit("update:modelValue", value.value);
    };

    const clear = () => {
      value.value = "";
      content.emit("update:modelValue", "");
      showSheet.value = false;
    };

    onMounted(() => {});

    return {
      value,
      minData,
      clear,
      showSheet,
      onDateTimePickerHandler
    };
  }
});
